import { CALL_SORTED_API } from 'gwx-voyager-components';
import Schemas from './preferences.schema';

const GET_PREFERENCES = [
	'PREFERENCES_REQUEST',
	'PREFERENCES_SUCCESS',
	'PREFERENCES_FAILURE'
];

const fetchPreferences = (query) => ({
	[CALL_SORTED_API]: {
		types: GET_PREFERENCES,
		endpoint: 'preferences',
		schema: Schemas.PREFERENCES,
		query,
		mapActionToStateKey: 'preferences'
	}
});

export const loadPreferences = (query) => (dispatch) => dispatch(
	fetchPreferences(query)
);

const UPDATE_PREFERENCES = [
	'PREFERENCES_REQUEST',
	'PREFERENCES_SUCCESS',
	'PREFERENCES_FAILURE'
];

const unsubscribeInternal = body => ({
	[CALL_SORTED_API]: {
		types: UPDATE_PREFERENCES,
		endpoint: 'preferences/unsubscribe',
		body,
		method: 'POST',
		schema: Schemas.PREFERENCES,
		mapActionToStateKey: 'preferences'
	}
});

const resubscribeInternal = body => ({
	[CALL_SORTED_API]: {
		types: UPDATE_PREFERENCES,
		endpoint: 'preferences/resubscribe',
		body,
		method: 'POST',
		schema: Schemas.PREFERENCES,
		mapActionToStateKey: 'preferences'
	}
});

export const unsubscribe = (body) => (dispatch) => dispatch(
	unsubscribeInternal(body)
);

export const resubscribe = (body) => (dispatch) => dispatch(
	resubscribeInternal(body)
);

const savePreferences = body => ({
	[CALL_SORTED_API]: {
		types: UPDATE_PREFERENCES,
		endpoint: 'preferences',
		body,
		method: 'POST',
		schema: Schemas.PREFERENCES,
		mapActionToStateKey: 'preferences'
	}
});

export const updatePreferences = (body) => (dispatch) => dispatch(
	savePreferences(body)
);

export const PreferencesActionTypes = {
	GET_PREFERENCES,
	UPDATE_PREFERENCES
};